import classNames from "classnames";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import { Icon } from "../icons/icon";
import { ProfileNotificationComponent } from "./profileNotificationComp";

export const TopNav = ({
  navOpen,
  setNavOpen,
  className,
  pageScrollProgress,
}: {
  navOpen: boolean;
  setNavOpen: (val: boolean) => void;
  className?: string;
  pageScrollProgress: number;
}) => {
  const { profile } = useAppSelector((state) => state.auth);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  return (
    <div
      className={`
      w-full
      bg-white px-5 md:px-8 py-[12px]
      border-b border-light-grey
      flex justify-between items-center
      lg:hidden z-[50]
      ${className}
      `}
    >
      <div className="hidden md:flex flex-row gap-4 items-center">
        <button
          type="button"
          onClick={!navOpen ? toggleNav : () => {}}
          className={`
          block lg:hidden
          hover:cursor-pointer
          transition-all
          `}
        >
          <Icon svg={"hamburger-icon"} width={24} height={24} className="" />
        </button>

        <Link
          className={`transition-all duration-500 pl-0 cursor pointer ${
            navOpen && "opacity-0 pl-20"
          }`}
          to={"/app/overview"}
        >
          <img src="/assets/images/logo.svg" alt="logo" className="md:hidden" />
          <img
            src="/assets/images/logo_desktop.svg"
            alt="logo"
            className="hidden md:flex"
          />
        </Link>
      </div>

      <div className="md:hidden transition-all duration-300">
        <p className="text-base text-pry-dark-green-400 font-medium">
          Hello,{" "}
          <b className="font-bold">
            {profile?.type === "member"
              ? profile?.FirstName
              : profile?.CoopName}
          </b>
        </p>
        <p
          className={classNames(
            "transition-all h-5 overflow-hidden duration-200 text-sm text-pry-dark-green-300/60",
            {
              "!h-0": pageScrollProgress > 0.1,
            }
          )}
        >
          Great to have you here!
        </p>
      </div>

      <ProfileNotificationComponent />
    </div>
  );
};
